/// <amd-module name="SuiteCommerce.GiftCertificate.ValueCheck.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.ValueCheck.Configuration", ["require", "exports", "SuiteCommerce.GiftCertificate.Utils.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ValueCheckConfiguration = void 0;
    var ValueCheckConfiguration = /** @class */ (function (_super) {
        __extends(ValueCheckConfiguration, _super);
        function ValueCheckConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ValueCheckConfiguration, "invalidCodeMessage", {
            get: function () {
                return this.get('giftcertbalance.invalidCodeMessage');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "inactiveCodeMessage", {
            get: function () {
                return this.get('giftcertbalance.inactiveCodeMessage');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "labelText", {
            get: function () {
                return this.get('giftcertbalance.labelText');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "buttonText", {
            get: function () {
                return this.get('giftcertbalance.buttonText');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "saveButtonText", {
            get: function () {
                return this.get('giftcertbalance.saveButtonText');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "placeholderText", {
            get: function () {
                return this.get('giftcertbalance.placeholderText');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "helpText", {
            get: function () {
                return this.get('giftcertbalance.helpText');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "inputFieldMinLength", {
            get: function () {
                return this.get('giftcertbalance.inputFieldMinLength');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "inputFieldMaxLength", {
            get: function () {
                return this.get('giftcertbalance.inputFieldMaxLength');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "expiredCodeMessage", {
            get: function () {
                return this.get('giftcertbalance.expiredCodeMessage');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "remainingBalanceLabel", {
            get: function () {
                return this.get('giftcertbalance.remainingBalanceLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "giftCertificateCodeLabel", {
            get: function () {
                return this.get('giftcertbalance.giftCertificateCodeLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "codeExpiredLabel", {
            get: function () {
                return this.get('giftcertbalance.codeExpiredLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "expiryDateLabel", {
            get: function () {
                return this.get('giftcertbalance.expiryDateLabel');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "invalidCodeFieldHelp", {
            get: function () {
                return this.get('giftcertbalance.invalidCodeFieldHelp');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "codeSavedMessage", {
            get: function () {
                return this.get('giftcertadvanced.codeSavedMessage');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "codeDuplicatedMessage", {
            get: function () {
                return this.get('giftcertadvanced.codeDuplicatedMessage');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "codeExpiredMessage", {
            get: function () {
                return this.get('giftcertadvanced.codeExpiredMessage');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(ValueCheckConfiguration, "generalWarning", {
            get: function () {
                return this.get('giftcertadvanced.generalWarning');
            },
            enumerable: false,
            configurable: true
        });
        return ValueCheckConfiguration;
    }(Configuration_1.Configuration));
    exports.ValueCheckConfiguration = ValueCheckConfiguration;
});
